import { EditRounded, AttachMoneyRounded } from '@mui/icons-material';
import TableCell from '@mui/material/TableCell';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { checkPermission } from '@/views/Facilities/CheckPermissions';
import { ENTITY_TYPE, REFUND_TYPES } from '@/utility';

const CustomerInfoCell = ({
  refund,
  role,
  isCustomPaymentTypesEnabled,
  onEditClick,
  onSendPaymentClick,
  onViewECheckClick,
}) => {
  const { t } = useTranslation();

  return (
    <TableCell data-testid={`transactionRowCustomer-${refund.id}`}>
      {refund.first_name} {refund.last_name}{' '}
      <a
        title='Edit Customer Information'
        data-testid={`editCustomerButton-${refund.id}`}
        onClick={onEditClick}>
        <EditRounded
          style={{ cursor: 'pointer', fontSize: '18px' }}
          fontSize='inherit'
        />
      </a>
      {role !== 'admin' &&
        checkPermission({
          parentKey: 'transaction_page',
          childKey: 'send_payment',
          permission: 'read',
        }) && (
          <a
            title='Send Payment'
            data-testid={`sendPaymentButton-${refund.id}`}
            onClick={onSendPaymentClick}>
            <AttachMoneyRounded
              style={{
                cursor: 'pointer',
                fontSize: '18px',
              }}
              fontSize='inherit'
            />
          </a>
        )}
      {isCustomPaymentTypesEnabled || role === 'admin' ? (
        refund.entity_type === ENTITY_TYPE.INDIVIDUAL && refund.email ? (
          <p style={{ fontSize: '12px' }}>({refund.email})</p>
        ) : refund.entity_type === ENTITY_TYPE.BUSINESS &&
          refund.business_payee_name ? (
          <p style={{ fontSize: '12px' }}>({refund.business_payee_name})</p>
        ) : refund.entity_type === ENTITY_TYPE.UNKNOWN ? (
          <p style={{ fontSize: '12px' }}>
            {refund.email && <>({refund.email})</>}
            {refund.email && refund.business_payee_name && ' '}
            {refund.business_payee_name && <>({refund.business_payee_name})</>}
          </p>
        ) : null
      ) : refund.refund_type === REFUND_TYPES.REGULAR && refund.email ? (
        <p style={{ fontSize: '12px' }}>({refund.email})</p>
      ) : (refund.refund_type === REFUND_TYPES.BUSINESS ||
          refund.refund_type === REFUND_TYPES.INSURANCE) &&
        refund.business_payee_name ? (
        <p style={{ fontSize: '12px' }}>({refund.business_payee_name})</p>
      ) : null}
      {refund.echeck_location && (
        <p
          style={{
            fontWeight: 'bold',
            fontSize: '12px',
            cursor: 'pointer',
            color: '#3AB795',
            margin: 0,
          }}
          onClick={onViewECheckClick}>
          {t('payments.table.viewECheck', 'View eCheck')}
        </p>
      )}
      {refund.has_files_attached && (
        <p
          style={{
            fontWeight: 'bold',
            fontSize: '12px',
          }}>
          {t('payments.table.pdfsAttached')}
        </p>
      )}
    </TableCell>
  );
};

export default CustomerInfoCell;
